import React from "react";

const RewardContent = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white section_space z-2 pt-0 pb-0 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          {/* <div className="col-lg-6"> */}
          <div className="col-lg-12">
            {/* <div className="border-end px-4"> */}
            <div>
              <div className="mt-4">
                <h1 className=" text-theme">
                  Understand How Your TopCoin UK Rewards Work
                </h1>
                <p className="text-dark opacity-50">
                  TopCoin UK is a loyalty and rewards programme. As you engage
                  with participating businesses, you collect free TopCoin and
                  may unlock additional company-funded cash rewards based on
                  predefined milestones.
                </p>
                <p className="text-dark opacity-50">
                  TopCoin is not money, not a financial product, and not an
                  investment. Cash rewards are discretionary loyalty benefits
                  provided by the company and are not guaranteed.
                </p>
                <p className="text-dark opacity-50">
                  At every level, As you engage with the TopCoin UK loyalty
                  programme, you unlock additional TopCoin rewards and
                  discretionary cash rewards provided by the company.
                </p>
                <p className="text-dark opacity-50">
                  To understand your reward progress, you can view the total
                  TopCoin you have collected and any associated rewards that
                  have been released, simply add the total value from each level
                  you’ve reached, including your TopCoin balance and any company
                  cash rewards that have been unlocked through loyalty
                  milestones.
                </p>
                <p className="text-dark opacity-50">
                  Our goal is to help you reach the highest level, where Our aim
                  is to reward long-term customer loyalty through a structured
                  rewards programme. Rewards are not guaranteed and are not
                  financial products. Because here, loyalty is recognised and
                  rewarded.
                </p>
                <p className="text-dark opacity-75 mb-0">
                  Understanding the Cash Wallets System
                </p>

                <p className="text-dark opacity-75 mb-0">
                  (Company-funded loyalty rewards, separate from TopCoin
                  balances)
                </p>
                <p className="text-dark opacity-50">
                  Cash Wallets are company-funded loyalty rewards that may be
                  released as customers reach specific TopCoin milestones. These
                  rewards are not savings accounts, investment products, or
                  interest-bearing instruments.
                </p>
                <p className="text-dark opacity-50">
                  TopCoin UK is a loyalty and rewards programme. It is not
                  regulated by the Financial Conduct Authority (FCA). TopCoin is
                  not a cryptocurrency, investment, or financial product. Cash
                  rewards are discretionary and subject to programme terms.
                </p>
                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      These cash rewards are released automatically as you
                      progress through your TopCoin Wallets:
                    </h5>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li>Bronze Cash reward wallet 1 opens at 20,000 TopCoin</li>
                      <li>
                        Nickel cash reward wallet 2 opens at 200,000 TopCoin  
                      </li>
                      <li>
                        Titanium cash reward wallet 3 opens at 2,000,000 TopCoin 
                      </li>
                      <li>
                        Silver cash reward wallet 4 opens at 4,000,000 TopCoin  
                      </li>
                      <li>
                        Palladium cash reward wallet 5 opens at 8,000,000 TopCoin   
                      </li>
                      <li>
                        Platinum cash reward wallet 6 opens at 12,000,000 TopCoin  
                      </li>
                      <li>
                        Iridium cash reward wallet 7 opens at 16,000,000 TopCoin  
                      </li>
                      <li>
                        Gold cash reward wallet 8 opens at 20,000,000 TopCoin
                      </li>
                      <li>
                        Eternity cash reward wallet 9 opens at 30,000,000 TopCoin
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <h2 className=" text-theme">
                  How Is Your Cash Share Calculated?
                </h2>
                {/* <ul className="text-dark-emphasis">
                  <li>Total TopCoin across all customers: 1,000,000</li>
                  <li>Your TopCoin at that level: 25,000</li>
                  <li>Cash in the wallet: £20,000</li>
                </ul> */}
                <h4 className="text-theme mt-3">
                  How the Reward Is Shared?
                </h4>
                <div className="d-flex flex-column text-dark-emphasis gap-3 mb-4">
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 1 – Wallet Allocation Basis</h5>
                    <p className="mb-0">
                      The total cash in the reward wallet is shared proportionally among eligible TopCoin holders at that wallet level.
                    </p>
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 2 – Your Proportional Share</h5>
                    <p className="mb-0">
                      Your share is calculated based on your TopCoin balance relative to the total TopCoin at that level.
                    </p>
                  </div>
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">Step 3 – Reward Release</h5>
                    <p className="mb-0">
                      Once the wallet milestone is unlocked, your allocated cash reward becomes available to withdraw, subject to platform rules and verification.
                    </p>
                  </div>

                </div>
                {/* <h4 className="mt-3 text-theme">
                  What Is My TopCoin UK Worth?
                </h4> */}
                <div className="d-flex flex-column mt-3 gap-3">
                  {/* <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3">
                    <h5 className="text-dark-emphasis">
                      To calculate your total value:
                    </h5>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        1. Add up the cash from every TopCoin UK Cash Wallet
                        you’ve unlocked
                      </li>
                      <li>
                        2. Add that to the TopCoin UK in your TopCoin Wallets
                      </li>
                    </ul>
                  </div> */}
                  <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3 mt-4 mb-4">
                    <h5 className="text-dark-emphasis">
                      Important Clarifications:
                    </h5>
                    <ul className="mb-0 text-dark-emphasis">
                      <li>
                        TopCoin UK is not an investment product
                      </li>
                      <li>
                        TopCoin does not represent ownership, equity, or profit rights
                      </li>
                      <li>
                        Cash rewards are not interest, yield, or financial returns
                      </li>
                      <li>
                        Examples shown are illustrative only
                      </li>
                      <li>
                        Rewards depend on platform activity and wallet unlock conditions
                      </li>
                    </ul>
                  </div>
                  {/* <div className="text-center text-dark-emphasis">
                    <p>
                      The total shows the real value of your journey with
                      TopCoin.
                    </p>
                  </div> */}
                </div>
              </div>
              <h4 className="text-theme mt-3">
                  How to View Your Total Rewards?
                </h4>
                <div className="shadow-sm border bg-white p-3 border-opacity-20 rounded-3 mt-3 mb-4">
                    <h5 className="text-dark-emphasis">
                      To see your total rewards:
                    </h5>
                    <ol className="mb-0 text-dark-emphasis">
                      <li>
                        View the cash rewards released from unlocked cash wallets
                      </li>
                      <li>
                        View your TopCoin balance separately in your TopCoin wallets
                      </li>
                    </ol>
                  </div>
                  <div className="text-center text-dark-emphasis ">
                    <strong>
                    <p>
                      These are loyalty rewards, not financial assets.
                    </p>

                    <p>
                      TopCoin UK is a loyalty and rewards platform. It is not regulated by the Financial Conduct Authority (FCA), as it does not provide financial services, investments, or payment products.
                    </p>
                    </strong>
                  </div>
              <div className="p-3 border text-center shadow-sm bg-primary rounded-5">
                <h5 className="mb-0 text-white">
                  Loyalty. Progress. Real Cash Rewards.
                </h5>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6">
            <div className="bg-primary rounded-4 mt-4 p-4">
              <div className="">
                <h1 className="text-white">
                  Welcome to TopCoin UK - Where Loyalty Turns into Real Rewards!
                </h1>
                <p className="text-white opacity-50">
                  Once someone joins TopCoin UK, they’re given their own
                  Personal ID and Referring customer’s numbers — instantly unlocking access to our
                  powerful earning system.
                </p>

                <div className="card bg-white border border-opacity-75 shadow-sm mt-3">
                  <div className="card-body">
                    <h5 className="fw-medium text-dark-emphasis fw-bold">
                      How Agents Earn Free TopCoin UK:
                    </h5>
                    <p className="text-dark-emphasis mb-1">
                      As a TopCoin UK Agent, you earn free units effortlessly
                      every time you refer someone!
                    </p>
                    <ul className="text-dark-emphasis opacity-75 py-2 mb-0">
                      <li> When someone you introduce makes a purchase,</li>
                      <li>And they enter yourReferring customer’s numbers,</li>
                      <li>
                        You’ll instantly receive the same number of TopCoin they
                        earn — automatically!
                      </li>
                    </ul>
                    <p className="mb-1 text-dark-emphasis">
                      The person must be a registered TopCoin UK member.
                    </p>
                    <p className="mb-0 text-dark-emphasis">
                      They must enter your Referring customer’s numbers at checkout.
                    </p>
                  </div>
                </div>
                <div className=" py-4">
                  <p className="mb-1 text-white opacity-50">
                    The more people you refer, the more your TopCoin balance grows
                    — and with it, your TopCoin UK wallet power. Start sharing.
                    Start earning. Be the reason others discover TopCoin UK —
                    and get rewarded every step of the way.
                  </p>
                  <p className="text-white opacity-50 mb-0">
                    Your loyalty is your power. Make it count.
                  </p>
                </div>
              </div>
            </div> */}
          {/* <div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 1</h5>
                  <p className="mb-0">from 1 to 19,999 units</p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 2</h5>
                  <p className="mb-0">
                    from 20,000 to 199,999 units at the start this wallet is
                    worth worth £100
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 3</h5>
                  <p className="mb-0">
                    from 200,000 to 1,999,999 unit at the start this wallet is
                    worth £1000
                  </p>
                </div>
              </div>

              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 4</h5>
                  <p className="mb-0">
                    from 2,000,000 to 9,999,999 at the start this wallet is
                    worth £10,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 5</h5>
                  <p className="mb-0">
                    from 10,000,000 to 19,999,999 at the start this wallet it’s
                    worth £50,000
                  </p>
                </div>
              </div>
              <div className="card bg-primary shadow-sm border-primary-subtle rounded-3 my-2">
                <div className="card-body">
                  <h5 className="mb-0">Wallet 6</h5>
                  <p className="mb-0">
                    20,000,000 Plus hit this wallet and you have earned £100,000
                    Plus
                  </p>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
};

export default RewardContent;
